import { Browser } from '../components/models/Browsers';
import { store } from '../store';
import { assemblyEditorSliceActions } from '../store/features/assemblyEditor/assemblyEditorSlice';

export const detectBrowser = () => {
  const userAgent = navigator.userAgent;
  let browser = Browser.Unknown;

  if (userAgent.includes('Edg/')) {
    browser = Browser.Edge;
  } else if (userAgent.includes('Chrome') && !userAgent.includes('Edg/')) {
    browser = Browser.Chrome;
  } else if (userAgent.includes('Firefox')) {
    browser = Browser.Firefox;
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    browser = Browser.Safari;
  } else {
    browser = Browser.Unknown;
  }

  store.dispatch(assemblyEditorSliceActions.setBrowser(browser));
};
